import { Button, Flexbox } from '@ibinder/common-frontend';
import React, { forwardRef } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  width: 450px;
  display: flex;
  flex-direction: column;
  height: 200px;
  background: ${({ theme }) => theme.colors.accent};
  box-shadow: ${({ theme }) => theme.shadows.primaryWithOpacity};
  padding: 1rem;
  position: fixed;
  top: 50%;
  left: 40%;
  transform: translate(-50%, -50%);

  button {
    margin-top: auto;
  }
`;

type Ref = HTMLDivElement;

type Props = {
  title: string;
  btnLabel: string;
  onClick: Function;
} & React.HTMLAttributes<HTMLButtonElement>;

const ActionBarModal = forwardRef<Ref, Props>(
  ({ title, onClick, btnLabel }, ref) => (
    <Container ref={ref}>
      <h2>{title}</h2>
      <Button btnStyle="primary" label={btnLabel} {...{ onClick }} />
    </Container>
  )
);

export default ActionBarModal;
